import { combineReducers, createReducer } from "@reduxjs/toolkit";
import {
  setQuizQuestions,
  setProducts,
  setUserGamingStyle,
  setIsQuizAnswered,
  setQuizAnswers,
  setSelectedProduct,
} from "state/actions";
import { AppState } from "./store";
import { Answer } from "utils/types";

const INITIAL_QUIZ_STATE = {
  questions: [],
};

const INITIAL_PRODUCTS = {
  products: [],
};

const INITIAL_USER_STATE = {
  gamingStyle: "",
  isQuizAnswered: false,
  quizAnswers: [
    {
      questionKey: "",
      answers: [""],
    },
  ],
  selectedProduct: {
    daily_price: 0,
    final_price: 0,
    original_price: 0,
    plan_name: "",
    product_key: "",
  },
};

const userReducer = createReducer(INITIAL_USER_STATE, (builder) => {
  builder.addCase(setUserGamingStyle, (state, { payload }) => {
    state.gamingStyle = payload;
  });

  builder.addCase(setIsQuizAnswered, (state, { payload }) => {
    state.isQuizAnswered = payload;
  });

  builder.addCase(setQuizAnswers, (state, { payload }) => {
    let updatedAnswers: Answer[] = state.quizAnswers;

    // NOTE: This filtering needed to rewrite user answers if user comes back to previous question and changes it's answer. Also filters out initial state answer.
    updatedAnswers = updatedAnswers.filter(
      (answer: Answer) =>
        answer.questionKey !== payload.questionKey && answer.questionKey !== ""
    );
    updatedAnswers.push(payload);

    state.quizAnswers = updatedAnswers;
  });

  builder.addCase(setSelectedProduct, (state, { payload }) => {
    state.selectedProduct = payload;
  });
});

const quizReducer = createReducer(INITIAL_QUIZ_STATE, (builder) => {
  builder.addCase(setQuizQuestions, (state, { payload }) => {
    state.questions = payload;
  });
});

const productsReducer = createReducer(INITIAL_PRODUCTS, (builder) => {
  builder.addCase(setProducts, (state, { payload }) => {
    state.products = payload;
  });
});

const reducers = combineReducers({
  quiz: quizReducer,
  products: productsReducer,
  user: userReducer,
});

export const quizQuestionsSelector = (state: AppState) => state.quiz.questions;
export const productsSelector = (state: AppState) => state.products.products;
export const userSelector = (state: AppState) => state.user;

export default reducers;